
export class Abstract {
  resetToArray(arr) {
    arr.length = 0;
    return arr;
  }
  addToArray(arr, el) {
    if (Array.isArray(el)) {
      arr.push(...el);
    } else {
      arr.push(el);
    }
    return arr;
  }
  removeToArray(arr, el) {
    arr = arr.filter(a => a !== el);
    return arr;
  }

  base64ToBlob(base64str: string, mimeType: string): Blob {
    // decode base64 string, remove space for IE compatibility
    const binary = atob(base64str.replace(/\s/g, ''));
    const len = binary.length;
    const buffer = new ArrayBuffer(len);
    const view = new Uint8Array(buffer);

    for (let i = 0; i < len; i++) {
      view[i] = binary.charCodeAt(i);
    }

    // create the blob object with content-type "application/pdf"
    return new Blob( [view], { type: mimeType });
  }
}



// WEBPACK FOOTER //
// ./src/app/abstract.ts